import { DictionaryTypeDto } from '@/api/generated';
import { SelectSearchOptionModel } from '@/components/form/model/SelectSearchOption.model.ts';
import { createContext, useContext } from 'react';

export type DictionariesContextProps = Record<DictionaryTypeDto, SelectSearchOptionModel<string>[]>;

export const DictionariesDefaultValues: DictionariesContextProps = {
  [DictionaryTypeDto.Location]: [],
  [DictionaryTypeDto.Status]: [],
  [DictionaryTypeDto.TypeOfStudy]: [],
  [DictionaryTypeDto.UniversityName]: [],
  [DictionaryTypeDto.YearOfStudy]: [],
};

export const DictionariesContext =
  createContext<DictionariesContextProps>(DictionariesDefaultValues);

export const useDictionariesContext = (): DictionariesContextProps => {
  return useContext<DictionariesContextProps>(DictionariesContext);
};
